import { Tag } from '@cian/components';
import * as React from 'react';

import { BuildingTypeName } from '../../../../types/commercial';
import { IBuildingTypeTag } from '../../../state/tags/definitions/building_type';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IBuildingTypeTagItemProps {
  tag: IBuildingTypeTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const BuildingTypeTagItem = ({ tag, onDeleteClick, withNewTag }: IBuildingTypeTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      {BuildingTypeName.get(tag.value)}
    </TagComponent>
  );
};
